import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base } from "../base";
import { Customer } from "../customers/customer";
import { IAddOrderItem, IUpdateOrderItem, OrderItem } from "./order-item";

export const Order = types
  .compose(
    Base,
    types.model({
      orderNumber: types.maybeNull(types.number),
      poDate: types.maybeNull(types.string),
      poNumber: types.maybeNull(types.string),
      customerId: types.maybeNull(types.string),
      customer: types.maybeNull(Customer),
      items: types.optional(types.array(OrderItem), []),
    })
  )
  .actions(withSetPropAction);
export interface IOrder extends Instance<typeof Order> {}
export interface IOrderProperties extends SnapshotIn<typeof Order> {}

export interface IAddOrder
  extends Pick<IOrderProperties, "poDate" | "poNumber" | "customerId"> {
  items: IAddOrderItem[];
}

export interface IUpdateOrder
  extends Pick<IOrderProperties, "poDate" | "id" | "poNumber" | "customerId"> {
  items: IUpdateOrderItem[];
}
